import {
  ACCEPT_INVITATION,
  FREE_TRIAL_RESET_PASSWORD_EMAIL,
  GET_HUB_INVITED_DATA,
  LOGIN,
  LOGIN_WITH_MAGIC_LINK,
  SEND_MAGIC_LINK,
  UPDATE_PASSWORD,
  registerAccountV2,
  verifyAccountV2,
} from "helper/url_helper";
import { toast } from "react-toastify";
import { axiosAccount } from "services/api";
import { get, set } from "services/cookies";
import { remove } from "services/localStorage";
import Track from "services/track";
import {
  fetchUserProfile,
  handleIsAuth,
  handleSetToken,
  setAuthOption,
  setDisableOtherStep,
  setGuestUerEmail,
  setGuestUser,
} from "store/actions";

import { errorTostHandler } from "helper/ErrorTostHandler";
import { isOrg } from "utils";
import {
  // FETCH_USER,
  // FETCH_USER_LOADING,
  MAGIC_LINK_LOADING,
  SET_INVITATION_DETAIL,
  VERIFY_ACCOUNT_,
  VERIFY_ACCOUNT_LOADING,
} from "./actionTypes";
const removeStorageLoginData = () => {
  remove("redirect_url");
  remove("site_id");
  remove("client_id");
  remove("source_page");
  remove("utm_campaign");
  remove("utm_medium");
  remove("utm_source");
  remove("utm_content");
  remove("utm_term");
  remove("sign_up");
  remove("partner");
  remove("target");
  remove("ref");
};

export const handleVerifyAccount = (payload, callback = () => {}) => {
  return async dispatch => {
    try {
      dispatch(verifyAccountLoading(true));
      const res = await axiosAccount.post(verifyAccountV2, payload);
      if (res?.data?.data) {
        let passData = {
          ...payload,
          ...res?.data?.data,
        };
        dispatch(verifyAccount(passData));
        callback(passData);
        dispatch(verifyAccountLoading(false));
      }
    } catch (err) {
      dispatch(verifyAccountLoading(false));
      errorTostHandler(err);
    }
  };
};

export const handelSendMagicLink = (payload, cb = () => {}) => {
  return async dispatch => {
    try {
      dispatch(sendMagicLinkLoading(true));
      const res = await axiosAccount.post(SEND_MAGIC_LINK, payload);
      if (res?.data) {
        cb(res);
        dispatch(sendMagicLinkLoading(false));
      }
    } catch (err) {
      dispatch(sendMagicLinkLoading(false));
      errorTostHandler(err);
    }
  };
};

export const handleLoginWithMagicLink = (
  data,
  navigate,
  isMagicLink = false,
  redirectUrl = "",
  redirectToDifferentSite = "",
  isPartner
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(verifyAccountLoading(true));
      const res = isMagicLink
        ? await axiosAccount.post(LOGIN_WITH_MAGIC_LINK, data)
        : await axiosAccount.post(LOGIN, {
            ...data,
            affiliate_visit_id: get("affiliate_visit_id") || 0,
          });
      if (res.data?.data) {
        if (data.isSSO && res.data?.data?.temptoken) {
          if (!!redirectToDifferentSite) {
            let appendWith = "?";
            if (redirectToDifferentSite.indexOf("?") !== -1) appendWith = "&";
            removeStorageLoginData();
            let redirectToDifferentSiteURL = redirectToDifferentSite?.replace(
              /"/g,
              ""
            );

            if (redirectToDifferentSiteURL.includes("growtogether")) {
              if (res.data?.data?.is_circle_access) {
                window.location.replace(
                  `${redirectToDifferentSiteURL}${appendWith}code=${res.data.data.temptoken}`
                );
              } else {
                navigate({
                  pathname: process.env.REACT_APP_REDIRECT_URL,
                  state: { is_from_login_together: true },
                });
              }
            } else {
              window.location.replace(
                `${redirectToDifferentSiteURL}${appendWith}code=${res.data.data.temptoken}`
              );
              return;
            }
          }
          return;
        }
        if (res.data.data?.user && res.data.data?.token) {
          dispatch(handleSetToken(res.data.data.token));
          set("token", res.data.data.token);
          if (!!redirectToDifferentSite && redirectToDifferentSite !== "null") {
            removeStorageLoginData();
            setTimeout(
              () =>
                window.location.replace(
                  redirectToDifferentSite?.replace(/"/g, "")
                ),
              1000
            );
          } else {
            if (!!redirectUrl && redirectUrl !== "/") {
              dispatch(handleIsAuth(true));
              dispatch(fetchUserProfile());
              const { subscriptionConfirmation } = getState();
              if (subscriptionConfirmation?.isGuestUser) {
                dispatch(setGuestUser(false));
                dispatch(setAuthOption(0));
                dispatch(setGuestUerEmail(null));
                dispatch(setDisableOtherStep(false));
              }
              navigate(redirectUrl);
            } else {
              let source_page = !!localStorage.getItem("source_page")
                ? JSON.parse(localStorage.getItem("source_page"))
                : "";

              let sign_up = !!localStorage.getItem("sign_up")
                ? JSON.parse(localStorage.getItem("sign_up"))
                : "";

              removeStorageLoginData();
              if (source_page === "free-trial-students") {
                window.location.replace(
                  `${process.env.REACT_APP_CURRICULUM_SITE_URL}/students-free-trial`
                );
              } else if (source_page === "free-trial-kids") {
                window.location.replace(
                  `${process.env.REACT_APP_CURRICULUM_SITE_URL}/kids-free-trial`
                );
              } else {
                if (!!sign_up) {
                  if (sign_up === "grow-free-trial-kids") {
                    window.location.replace(
                      `${process.env.REACT_APP_FREE_TRIAL_SITE_URL}/kids`
                    );
                  }
                  if (sign_up === "grow-free-trial-students") {
                    window.location.replace(
                      `${process.env.REACT_APP_FREE_TRIAL_SITE_URL}/students`
                    );
                  }
                  if (sign_up === "free-trial") {
                    window.location.replace(
                      process.env.REACT_APP_FREE_TRIAL_SITE_URL
                    );
                  }
                } else {
                  if (isPartner) {
                    window.location.replace(
                      (
                        process.env.REACT_APP_CURRICULUM_SITE_URL_2 +
                        `?partner=${isPartner}`
                      )?.replace(/"/g, "")
                    );
                  } else {
                    window.location.replace(
                      process.env.REACT_APP_CURRICULUM_SITE_URL_2?.replace(
                        /"/g,
                        ""
                      )
                    );
                  }
                }
              }
            }
          }
        }
      }
      dispatch(verifyAccountLoading(false));
    } catch (err) {
      if (isMagicLink) navigate("/");
      dispatch(verifyAccountLoading(false));
      errorTostHandler(err);
    }
  };
};

export const handleSignUpWithMagicLink = (
  data,
  navigate,
  redirectUrl,
  redirectToDifferentSite,
  isVBSSignUp,
  isFreeTrialOrHubOrSlidrSignUp,
  isPartner,
  content,
  cb = () => {} //Check this
) => {
  return async dispatch => {
    try {
      dispatch(verifyAccountLoading(true));
      const res = await axiosAccount.post(registerAccountV2, {
        ...data,
        affiliate_visit_id: get("affiliate_visit_id") || 0,
      });

      const tracking = isOrg && (isVBSSignUp || isFreeTrialOrHubOrSlidrSignUp);

      const redirectFunc = () => {
        if (data?.source_page === "free-trial-kids") {
          window.location.replace(
            process.env.REACT_APP_CURRICULUM_SITE_URL_2 +
              "kids-free-trial?ref=trial"
          );
        } else if (data?.source_page === "free-trial-students") {
          window.location.replace(
            process.env.REACT_APP_CURRICULUM_SITE_URL_2 +
              "students-free-trial?ref=trial"
          );
        } else {
          if (isPartner) {
            window.location.replace(
              (
                process.env.REACT_APP_CURRICULUM_SITE_URL_2 +
                `?partner=${isPartner}`
              )?.replace(/"/g, "")
            );
          } else {
            window.location.replace(
              process.env.REACT_APP_CURRICULUM_SITE_URL_2?.replace(/"/g, "")
            );
          }
        }
      };

      if (res.status) {
        cb();
        if (redirectToDifferentSite?.includes("?ref=vbs")) {
          window.gtag("event", "new_free_vbs_user", {
            event_category: "New VBS sign up",
          });
        }
        dispatch(verifyAccountLoading(false));
        if (tracking) {
          Track.signUp(isVBSSignUp, isFreeTrialOrHubOrSlidrSignUp);
        }
        if (res.data?.data?.user_data?.is_user_exist === 1) {
          toast.error(res.data.message);
          return;
        }
        if (res.data.data?.user && res.data.data?.token) {
          toast.success(res.data.message);
          dispatch(handleSetToken(res.data.data.token));
          if (!!redirectToDifferentSite && redirectToDifferentSite !== "null") {
            removeStorageLoginData();
            window.location.replace(redirectToDifferentSite?.replace(/"/g, ""));
          } else {
            if (!!redirectUrl && redirectUrl !== "/") {
              dispatch(handleIsAuth(true));
              dispatch(fetchUserProfile());
              navigate(redirectUrl);
            } else if (tracking) setTimeout(redirectFunc, 2000);
            else redirectFunc();
          }
        }
      }
    } catch (err) {
      dispatch(verifyAccountLoading(false));
      errorTostHandler(err);
    }
  };
};

export const handelSendForgetPasswordLink = (payload, cb = () => {}) => {
  return async dispatch => {
    try {
      dispatch(sendMagicLinkLoading(true));
      const res = await axiosAccount.post(
        FREE_TRIAL_RESET_PASSWORD_EMAIL,
        payload
      );
      if (res?.data) {
        toast.success("Reset password link is sent, please check your email.");
        dispatch(sendMagicLinkLoading(false));
        cb(res?.data);
      }
    } catch (err) {
      dispatch(sendMagicLinkLoading(false));
      errorTostHandler(err);
    }
  };
};

export const handleRestPassword = (data, cb) => {
  return async dispatch => {
    try {
      dispatch(verifyAccountLoading(true));
      const res = await axiosAccount.post(UPDATE_PASSWORD, data);
      if (res.data?.data) {
        cb();
      }
    } catch (err) {
      dispatch(verifyAccountLoading(false));
      errorTostHandler(err);
    }
  };
};

export const getAcceptInviteData = ({ data, navigate }) => {
  return async dispatch => {
    try {
      dispatch(verifyAccountLoading(true));
      const res = await axiosAccount.post(GET_HUB_INVITED_DATA, data);
      if (res.data?.data) {
        if (Object.keys(res.data.data).length === 0) {
          toast.error(res?.data?.message);
          navigate("/login");
        } else {
          dispatch(setAccessInvite(res.data.data));
        }
      }
      dispatch(verifyAccountLoading(false));
    } catch (err) {
      window.location.replace(process.env.REACT_APP_HUB_SITE_URL);
      errorTostHandler(err);
      dispatch(verifyAccountLoading(false));
    }
  };
};

export const handleAcceptInvitation = (data, redirectUrl) => {
  return async dispatch => {
    try {
      dispatch(verifyAccountLoading(true));
      const res = await axiosAccount.post(ACCEPT_INVITATION, data);
      if (res.data?.data) {
        if (res.data.data?.user && res.data.data?.token) {
          window.location.replace(process.env.REACT_APP_CURRICULUM_SITE_URL_2);
        }
        removeStorageLoginData();
        if (!!redirectUrl) window.location.replace(redirectUrl);
      }
      dispatch(verifyAccountLoading(false));
    } catch (err) {
      errorTostHandler(err);
      dispatch(verifyAccountLoading(false));
    }
  };
};

const verifyAccountLoading = data => ({
  type: VERIFY_ACCOUNT_LOADING,
  payload: data,
});

const verifyAccount = data => ({
  type: VERIFY_ACCOUNT_,
  payload: data,
});

const sendMagicLinkLoading = data => ({
  type: MAGIC_LINK_LOADING,
  payload: data,
});

export const setAccessInvite = data => ({
  type: SET_INVITATION_DETAIL,
  payload: data,
});
